<template>
  <chart class="qj-echarts" ref="chart" :options="options"></chart>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      defaultOptions: {
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            type: "pie",
            radius: "65%",
            label: {
              formatter: "{b}\n{c}",
            },
            data: [
              { value: 1048, name: "Search Engine" },
              { value: 735, name: "Direct" },
              { value: 580, name: "Email" },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.8)",
              },
            },
          },
        ],
      },
    };
  },
  computed: {
    options() {
      if (!this.data) return this.defaultOptions;
      return this.renderChart();
    },
  },
  methods: {
    renderChart() {
      let options = { ...this.defaultOptions };
      options.series[0].data = [
        {
          value: this.data.cellphone_quality_bad,
          name: "Ruim",
        },
        {
          value: this.data.cellphone_quality_avg,
          name: "Média",
        },
        {
          value: this.data.cellphone_quality_good,
          name: "Boa",
        },
      ];
      return options;
    },
  },
};
</script>

<style></style>
